import React, { Component, useEffect, useState } from 'react';
import './About.css';
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import profilepic1 from "../Assets/Images/P1.webp";
import profilepic2 from "../Assets/Images/P2.webp";
import profilepic3 from "../Assets/Images/P3.webp";
import DarkModeToggle from '../Dark/DarkModeToggle';
import '../Dark/styles.scss';

const About = (props) => {

    const [hobbiesState, updateHobbiesState] = useState(false) ;
    
    const updateHobby = () => {
      const newHobby=!hobbiesState;
      updateHobbiesState(newHobby);
    }
    const animation = useAnimation();    
    const [ref, inView, entry] = useInView({ threshold: 0.1 });
    const variants1 = {
      visible: { opacity: 1, marginLeft: 0 },
      hidden: { opacity: 0, marginLeft: -500},
    }
    const variants2 = {
      visible: { opacity: 1, marginTop: 0 },
      hidden: { opacity: 0, marginTop: -500},
    }
    const variants3 = {
      visible: { opacity: 1, marginRight: 0 },
      hidden: { opacity: 0, marginRight: -500},
    }

    const variantsR = {
      visible: { opacity: 1, marginRight: 0 },
      hidden: { opacity: 0, marginRight: -500},
    }
    const transition = {
      delay: 1
    }
    useEffect(() => {
      if (inView) {
        animation.start("visible");
      } else {
        animation.start("hidden");
      }
    }, [animation, inView]);

      var title=null;

    
      const hobbyFinal= <motion.div 
                    ref={ref}
                    animate={animation}
                    initial="hidden"
                    transition={transition}
                    variants={variantsR}
                    title=""
                    className="Hobby">
                  <p className="address">
              <span>I like Singing. 🎤 </span><br />
              <span>I write poems 📝 and songs too. ♫♪♪ </span><br />
              <span>I like travelling 🏍️....YES! <b>A TravelFreak ✈️</b><br />
                    
                  </span><br />
 
              </p>

              <motion.button
               className="btn"
              onClick={updateHobby}
               whileHover={{ scale: 1.1 }}
               whileTap={{ scale: 0.9 }}>
                  BACK

            </motion.button>
            </motion.div>;
              

      const aboutFinal = <motion.div 
      ref={ref}
      animate={animation}
      initial="hidden"
      transition={transition}
      variants={variantsR}
      title=""

      className="Content">
      <h2></h2>
    <p className="address">
 <span>I am a <b>Software Engineer</b>. I am a B.Tech graduate from <b>IIT Roorkee.</b></span><br />
 <span>I have a passion for UI effects, animations and creating intuitive dynamic <b>user experiences.</b><br /></span>
    <span> I prefer <b>CamelCase</b> over UPPERCASE/lowercase.</span>  
     <br />
 
</p>
<motion.button
 className="btn"
 onClick={updateHobby}
  whileHover={{ scale: 1.1 }}
  whileTap={{ scale: 0.9 }}>
  MY HOBBIES?

</motion.button>
</motion.div>;



            
    return (
         <section id="about">
         <div className="Title">ABOUT </div>
         
        <div
        className="About">
              

              <div className="pic">
                <motion.div 
                    ref={ref}
                    animate={animation}
                    
                    initial="hidden"
                    tr
                    variants={variants1}
                    className="DP1">
                        <img className="profile-pic"  src={profilepic1} alt="Mohammad Zaryab's Profile Pic" />
            </motion.div>
            <motion.div 
                    ref={ref}
                    animate={animation}
                    initial="hidden"
        
                    variants={variants2}
                    className="DP2">
                        <img className="profile-pic"  src={profilepic2} alt="Mohammad Zaryab's Profile Pic" />
            </motion.div>
            <motion.div 
                    ref={ref}
                    animate={animation}
                    
                    initial="hidden"
        
                    variants={variants3}
                    className="DP3">
                        <img className="profile-pic"  src={profilepic3} alt="Mohammad Zaryab's Profile Pic" />
            </motion.div>

            </div>
            <motion.div 
                    ref={ref}
                    animate={animation}
                    initial="hidden"
                    transition={transition}
                    variants={variantsR}
                    className="Content">
                    {hobbiesState? hobbyFinal : aboutFinal}
                    </motion.div>
            
        </div>
            

   </section>
      
    );
  }

export default About;
